import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.shopDetails.components.ShopIsClosedModal.title',
    defaultMessage: '{shopGender} {shopType} está {isClosed}',
  },
  subtitle: {
    id: 'app.shopDetails.components.ShopIsClosedModal.subtitle',
    defaultMessage:
      '{shopGender} {shopType} está {isClosed} y no es posible agregar productos',
  },
});
